import { pusherAuth } from 'api/actions/profile';
import { fetcher } from 'api/client';

const {
  REACT_APP_PUSHER,
  REACT_APP_PUSHER_CLUSTER,
} = process.env;

export const pusherConfig = {
  clientKey: REACT_APP_PUSHER,
  cluster: REACT_APP_PUSHER_CLUSTER,
  encrypted: true
}

export const pusherAuthorizer = (channel, options, jwt) => ({
  authorize: function (socket_id, callback) {
    fetcher(pusherAuth({ socket_id, channel_name: channel?.name }), jwt)
      .then((data) => {
        callback(null, data);
      })
      .catch((error) => {
        console.error(error);
        callback(new Error('Error calling auth endpoint'), { auth: '' });
      });
  }
})